import React, { useState, useEffect } from 'react';
import './FollowUpFilterationActions.css';
import './FollowUpEditModal.css';
import {
    X, Phone, MessageSquare, Mail, Settings,
    Calendar, User, Clock, CheckCircle,
    Plus, MapPin, Search, Edit3, Building,
    Download, Upload, Filter, MoreHorizontal, ChevronDown, Hourglass
} from 'lucide-react';
import { Icon } from '@iconify/react';
import API_ENDPOINTS from '../../../config/apiEndpoints';
import { LeadDetails as CommonLeadDetails } from '../../../components/common/LeadDetails/LeadDetails';
import Loader from '../../../components/Loader/Loader';
import { getSession } from '../../../getSession';

const countryList = [
    { name: "Afghanistan", dialCode: "+93", flag: "🇦🇫", code: "AF" },
    { name: "Albania", dialCode: "+355", flag: "🇦🇱", code: "AL" },
    { name: "Algeria", dialCode: "+213", flag: "🇩🇿", code: "DZ" },
    { name: "Andorra", dialCode: "+376", flag: "🇦🇩", code: "AD" },
    { name: "Angola", dialCode: "+244", flag: "🇦🇴", code: "AO" },
    { name: "Argentina", dialCode: "+54", flag: "🇦🇷", code: "AR" },
    { name: "Armenia", dialCode: "+374", flag: "🇦🇲", code: "AM" },
    { name: "Australia", dialCode: "+61", flag: "🇦🇺", code: "AU" },
    { name: "Austria", dialCode: "+43", flag: "🇦🇹", code: "AT" },
    { name: "Bahrain", dialCode: "+973", flag: "🇧🇭", code: "BH" },
    { name: "Bangladesh", dialCode: "+880", flag: "🇧🇩", code: "BD" },
    { name: "Belgium", dialCode: "+32", flag: "🇧🇪", code: "BE" },
    { name: "Brazil", dialCode: "+55", flag: "🇧🇷", code: "BR" },
    { name: "Canada", dialCode: "+1", flag: "🇨🇦", code: "CA" },
    { name: "China", dialCode: "+86", flag: "🇨🇳", code: "CN" },
    { name: "Egypt", dialCode: "+20", flag: "🇪🇬", code: "EG" },
    { name: "France", dialCode: "+33", flag: "🇫🇷", code: "FR" },
    { name: "Germany", dialCode: "+49", flag: "🇩🇪", code: "DE" },
    { name: "India", dialCode: "+91", flag: "🇮🇳", code: "IN" },
    { name: "Indonesia", dialCode: "+62", flag: "🇮🇩", code: "ID" },
    { name: "Iran", dialCode: "+98", flag: "🇮🇷", code: "IR" },
    { name: "Iraq", dialCode: "+964", flag: "🇮🇶", code: "IQ" },
    { name: "Israel", dialCode: "+972", flag: "🇮🇱", code: "IL" },
    { name: "Italy", dialCode: "+39", flag: "🇮🇹", code: "IT" },
    { name: "Japan", dialCode: "+81", flag: "🇯🇵", code: "JP" },
    { name: "Jordan", dialCode: "+962", flag: "🇯🇴", code: "JO" },
    { name: "Kuwait", dialCode: "+965", flag: "🇰🇼", code: "KW" },
    { name: "Malaysia", dialCode: "+60", flag: "🇲🇾", code: "MY" },
    { name: "Mexico", dialCode: "+52", flag: "🇲🇽", code: "MX" },
    { name: "Nepal", dialCode: "+977", flag: "🇳🇵", code: "NP" },
    { name: "Netherlands", dialCode: "+31", flag: "🇳🇱", code: "NL" },
    { name: "New Zealand", dialCode: "+64", flag: "🇳🇿", code: "NZ" },
    { name: "Oman", dialCode: "+968", flag: "🇴🇲", code: "OM" },
    { name: "Pakistan", dialCode: "+92", flag: "🇵🇰", code: "PK" },
    { name: "Philippines", dialCode: "+63", flag: "🇵🇭", code: "PH" },
    { name: "Qatar", dialCode: "+974", flag: "🇶🇦", code: "QA" },
    { name: "Russia", dialCode: "+7", flag: "🇷🇺", code: "RU" },
    { name: "Saudi Arabia", dialCode: "+966", flag: "🇸🇦", code: "SA" },
    { name: "Singapore", dialCode: "+65", flag: "🇸🇬", code: "SG" },
    { name: "South Africa", dialCode: "+27", flag: "🇿🇦", code: "ZA" },
    { name: "South Korea", dialCode: "+82", flag: "🇰🇷", code: "KR" },
    { name: "Spain", dialCode: "+34", flag: "🇪🇸", code: "ES" },
    { name: "Sri Lanka", dialCode: "+94", flag: "🇱🇰", code: "LK" },
    { name: "Switzerland", dialCode: "+41", flag: "🇨🇭", code: "CH" },
    { name: "Thailand", dialCode: "+66", flag: "🇹🇭", code: "TH" },
    { name: "Turkey", dialCode: "+90", flag: "🇹🇷", code: "TR" },
    { name: "United Arab Emirates", dialCode: "+971", flag: "🇦🇪", code: "AE" },
    { name: "United Kingdom", dialCode: "+44", flag: "🇬🇧", code: "GB" },
    { name: "United States", dialCode: "+1", flag: "🇺🇸", code: "US" },
    { name: "Vietnam", dialCode: "+84", flag: "🇻🇳", code: "VN" },
    { name: "Yemen", dialCode: "+967", flag: "🇾🇪", code: "YE" },
    { name: "Zambia", dialCode: "+260", flag: "🇿🇲", code: "ZM" },
    { name: "Zimbabwe", dialCode: "+263", flag: "🇿🇼", code: "ZW" }
];

const FollowUpFilterationActions = ({
    viewMode, showLeadProfile,
    onCloseLeadProfile, leadData,
    showEditModal, onCloseEditModal, editLeadData,
    onExport, onCustomDownload
}) => {

    const [isProfileOpen, setIsProfileOpen] = useState(false);
    const [scorecardData, setScorecardData] = React.useState(null);
    const [activeTab, setActiveTab] = React.useState('Activities');
    const [taskHistoryData, setTaskHistoryData] = useState([]);
    const [loadingTasks, setLoadingTasks] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [leadFormData, setLeadFormData] = useState({});
    const [editFormData, setEditFormData] = useState({});
    const [loadingEditData, setLoadingEditData] = useState(false);
    const [courseOptions, setCourseOptions] = useState([]);
    const [centerOptions, setCenterOptions] = useState([]);
    const [campaignOptions, setCampaignOptions] = useState([]);
    const [mediumOptions, setMediumOptions] = useState([]);
    const [sourceOptions, setSourceOptions] = useState([]);
    const [countryOptions, setCountryOptions] = useState([]);
    const [leadSearchSuggestions, setLeadSearchSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [isSearchingLeads, setIsSearchingLeads] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState(countryList.find(c => c.code === "IN") || countryList[0]);
    const [isCountryDropdownOpen, setIsCountryDropdownOpen] = useState(false);
    const [countrySearch, setCountrySearch] = useState("");
    const [showMoreOtherDetails, setShowMoreOtherDetails] = useState(false);
    const [leadDetailData, setLeadDetailData] = useState(null);







    const leadId = leadData?.LeadId || leadData?.enquiryId || leadData?.id || leadData?.ID;



    const TOKEN = API_ENDPOINTS.TOKE.UNIVERSAL_TOKEN;
    const API_BASE = (process.env.REACT_APP_WCF_API_BASE_URL || '').replace(/\/$/, '');
    const API_BASE1 = (process.env.REACT_APP_SERVICES_AZURE_BASEURL || '').replace(/\/$/, '');
    const NEWV3_BASE_URL_INTERNAL = (process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '');
    const GET_SCORECARD_DETAILS = `${NEWV3_BASE_URL_INTERNAL}${API_ENDPOINTS.FOLLOWUPS.SCORE_CARD_DETAILS}`;
    const TASK_HISTORY = `${API_BASE}${API_ENDPOINTS.FOLLOWUPS.SCORE_CARD_DETAILS}`;
    const center_of_edication = `${NEWV3_BASE_URL_INTERNAL}${API_ENDPOINTS.FOLLOWUPS.GET_CENTER_OF_EDUCATION_EDIT}`;
    const Get_campaign_for_edit = `${API_BASE}${API_ENDPOINTS.FOLLOWUPS.GET_CAMPAIGN_FOR_EDIT}`;
    const Get_country_for_edit = `${NEWV3_BASE_URL_INTERNAL}/Common/GetCountryList`;

    const DEV_BASE_URL = (process.env.REACT_APP_BACKEND_BASEURL_FOR_DEVELOPMENT || '').replace(/\/$/, '');
    const GetScorecard_details = `${DEV_BASE_URL}${API_ENDPOINTS.PIPELINE.GET_SCORECARD_DETAILS_NEW}`;
    const EDIT_CUSTOM_FIELDS = `${NEWV3_BASE_URL_INTERNAL}/UserCRM/GetAllSegmentList`;
    const SaveEdit = `${NEWV3_BASE_URL_INTERNAL}/UserCRM/EditLead`;
    const SaveFollowUp = `${API_BASE1}${API_ENDPOINTS.FOLLOWUPS.ADD_FOLLOWUP_DLT}`;



    const token = API_ENDPOINTS.TOKE.UNIVERSAL_TOKEN;
    const GetLeadDetailByLeadId = `${DEV_BASE_URL}${API_ENDPOINTS.PIPELINE.GET_SCORECARD_DETAILS_NEW}`;

    const buildLeadDetailPayload = (leadId) => {
        const { userId, parentId, TokenId } = getSession();
        return {
            Token: TokenId || TOKEN || "-2295521862261168",
            Message: "",
            LoggedUserId: userId || localStorage.getItem('userId') || '34594',
            MAC_Address: "",
            IP_Address: "",
            BroadcastName: "",
            Details: {
                LeadId: parseInt(leadId, 10),
                ParentId: String(parentId)
            }
        };
    };

    const parseLeadDetailResponse = async (resp) => {
        if (!resp) return null;
        const text = await resp.text();
        let jsonObj = null;

        // Handle XML-wrapped response from ASMX services
        const xmlMatch = text.match(/<string[^>]*>([\s\S]*?)<\/string>/);
        if (xmlMatch) {
            try { jsonObj = JSON.parse(xmlMatch[1]); } catch (e) { console.error('XML parse error:', e); }
        }

        // Handle plain JSON response
        if (!jsonObj) {
            try { jsonObj = JSON.parse(text); } catch (e) { console.error('JSON parse error:', e); }
        }
        if (!jsonObj) {
            console.error('parseLeadDetailResponse: Could not parse response');
            return null;
        }

        let raw = jsonObj.d || jsonObj.Details || jsonObj.details;
        if (!raw) {
            raw = jsonObj;
        }

        if (typeof raw === 'string') {
            try { raw = JSON.parse(raw); } catch (e) { /* keep-as is */ }
        }

        if (raw && typeof raw === 'object' && !Array.isArray(raw) && (raw.Details || raw.d)) {
            let inner = raw.Details || raw.d;
            if (typeof inner === 'string') {
                try { inner = JSON.parse(inner); } catch (e) { /* keep */ }
            }
            raw = inner;
        }

        const info = Array.isArray(raw) ? raw[0] : raw;
        return (info && typeof info === 'object') ? info : null;
    };

    const fetchLeadDetailById = async () => {
        try {
            const lId = leadData?.LeadId || leadData?.enquiryId || leadData?.id || leadData?.ID;
            if (!lId) { console.warn('fetchLeadDetailById: No LeadId'); return; }
            console.log('fetchLeadDetailById: Fetching for LeadId:', lId, 'URL:', GetLeadDetailByLeadId);

            const resp = await fetch(GetLeadDetailByLeadId, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(buildLeadDetailPayload(lId))
            });

            if (!resp.ok) {
                console.error('fetchLeadDetailById: Response not ok', resp.status);
                return;
            }

            const info = await parseLeadDetailResponse(resp);
            console.log('fetchLeadDetailById: Final data:', info);
            console.log('fetchLeadDetailById: fields:', info ? Object.keys(info) : []);
            if (info) {
                setLeadDetailData(info);
            }
        } catch (e) {
            console.error('Error fetching lead detail by id:', e);
        }
    };

    const fetchScorecardDetails = async () => {
        try {
            const leadId = leadData?.LeadId || leadData?.enquiryId || leadData?.id || leadData?.ID;
            if (!leadId) return;

            const payload = {
                Token: "-2295521862261168",
                Details: { EnquiryID: leadId.toString() }
            };

            const response = await fetch(GET_SCORECARD_DETAILS, {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=utf-8" },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const result = await response.json();
                const details = result.Details?.[0] || result.d?.[0] || result.Details || result.d;
                if (details) {
                    let data = typeof details === 'string' ? JSON.parse(details) : details;
                    if (Array.isArray(data) && data.length > 0) {
                        data = data[0];
                    }
                    setScorecardData(data);
                    // Also set leadDetailData for Other Details expanded view
                    setLeadDetailData(data);
                    // Also update leadFormData for editing consistency
                    setLeadFormData(data || {});
                }
            }
        } catch (error) {
            console.error("Error fetching scorecard details:", error);
        }
    };

    const fetchTaskHistory = async () => {
        setLoadingTasks(true);
        try {
            const leadId = leadData?.LeadId || leadData?.enquiryId || leadData?.id;
            const userId = localStorage.getItem('userId') || '34594';
            if (!leadId) return;

            const payload = {
                FilterText: ` AND LeadId = ${leadId}`,
                Mode: "T",
                IP_Address: "",
                LoggedUserId: userId,
                MAC_Address: "",
                Message: "",
                Token: token
            };

            const response = await fetch(TASK_HISTORY, {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=utf-8" },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const result = await response.json();
                if (result.d) {
                    const data = typeof result.d === 'string' ? JSON.parse(result.d) : result.d;
                    setTaskHistoryData(data || []);
                }
            }
        } catch (error) {
            console.error("Error fetching task history:", error);
        } finally {
            setLoadingTasks(false);
        }
    };

    const fetchEditLeadDetails = async (id = null) => {
        setLoadingEditData(true);
        try {
            const leadId = id || editLeadData?.LeadId || editLeadData?.enquiryId || editLeadData?.id || editLeadData?.ID;
            if (!leadId) {
                console.warn("No LeadId found for fetching details");
                setLoadingEditData(false);
                return;
            }

            const payload = {
                Token: "-2295521862261168",
                Details: { EnquiryID: leadId.toString() }
            };

            const response = await fetch(GET_SCORECARD_DETAILS, {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=utf-8" },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const result = await response.json();
                const details = result.Details?.[0] || result.d?.[0] || result.Details || result.d;
                if (details) {
                    let data = typeof details === 'string' ? JSON.parse(details) : details;
                    if (Array.isArray(data) && data.length > 0) {
                        data = data[0];
                    }
                    console.log("Edit Lead Data from Scorecard API:", data); // Debug log

                    // Normalize data to ensure field names match JSX (case-insensitive fallback)
                    const normalizedData = { ...data };
                    // Add lowercase versions of all keys if they don't exist
                    Object.keys(data).forEach(key => {
                        const lowerKey = key.toLowerCase();
                        if (!normalizedData[lowerKey]) {
                            normalizedData[lowerKey] = data[key];
                        }
                    });

                    setEditFormData(normalizedData || {});
                }
            }
        } catch (error) {
            console.error("Error fetching edit lead details:", error);
        } finally {
            setLoadingEditData(false);
        }
    };

    const handleLeadSearch = async (value, field = 'Name') => {
        console.log(`handleLeadSearch called for field: ${field} with value:`, value);

        // Update the specific field in form data
        setEditFormData(prev => ({ ...prev, [field]: value }));

        if (!value || value.trim().length < 2) {
            console.log(`Search query "${value}" too short (<2 chars), skipping API call`);
            setLeadSearchSuggestions([]);
            setShowSuggestions(false);
            return;
        }

        try {
            setIsSearchingLeads(true);
            const payload = { Token: "-2295521862261168", Details: { strFilter: value } };
            console.log(`[SEARCH TRIGGERED] URL: ${EDIT_CUSTOM_FIELDS} | Payload: ${JSON.stringify(payload)}`);

            const response = await fetch(EDIT_CUSTOM_FIELDS, {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=utf-8" },
                body: JSON.stringify(payload)
            });

            console.log(`[SEARCH RESPONSE] Status: ${response.status} ${response.statusText}`);

            if (response.ok) {
                const result = await response.json();
                console.log("[SEARCH DATA RECEIVED]", result);

                const d = result.d || result;
                if (d) {
                    const data = typeof d === 'string' ? JSON.parse(d) : d;
                    console.log(`[SEARCH PARSED] Found ${Array.isArray(data) ? data.length : 0} suggestions`);
                    setLeadSearchSuggestions(Array.isArray(data) ? data : []);
                    setShowSuggestions(true);
                } else {
                    console.log("[SEARCH] No data property (d) in response");
                    setShowSuggestions(false);
                }
            } else {
                console.warn(`[SEARCH FAILED] API returned non-OK status: ${response.status}`);
            }
        } catch (error) {
            console.error("[SEARCH ERROR] Exception during fetch:", error);
        } finally {
            setIsSearchingLeads(false);
        }
    };

    const handleSelectSuggestion = (lead) => {
        console.log("[SUGGESTION SELECTED]", lead);
        const selectedName = lead.PersonName || lead.Name || lead.name;

        setEditFormData(prev => ({
            ...prev,
            Name: selectedName || prev.Name,
            PersonName: selectedName || prev.PersonName,
            LeadTags: selectedName || prev.LeadTags, // Clear or update the search field
            LeadId: lead.LeadId || lead.id || lead.ID || prev.LeadId,
            MobileNo: lead.MobileNo || lead.Mobile || lead.mobile || prev.MobileNo,
            Email: lead.EmailID || lead.Email || lead.email || prev.Email
        }));
        setShowSuggestions(false);

        const selectedLeadId = lead.LeadId || lead.id || lead.ID;
        if (selectedLeadId) {
            console.log(`[ACTION] Fetching full details for selected Lead ID: ${selectedLeadId}`);
            fetchEditLeadDetails(selectedLeadId);
        }
    };

    const fetchEducationOptions = async () => {
        try {
            const leadId = leadData?.LeadId || leadData?.enquiryId || leadData?.id || editLeadData?.LeadId || editLeadData?.id || 42957;
            const payload = {
                Token: "-2295521862261168",
                Details: { leadno: parseInt(leadId), parentid: 34594 }
            };

            const response = await fetch(center_of_edication, {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=utf-8" },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const result = await response.json();
                const rawDetails = result.Details?.[0] || result.d?.[0] || result.Details || result.d;
                if (rawDetails) {
                    let data = typeof rawDetails === 'string' ? JSON.parse(rawDetails) : rawDetails;
                    if (Array.isArray(data) && data.length > 0) {
                        data = data[0];
                    }

                    // Parse Choices field which contains comma-separated values
                    if (data.Choices) {
                        const options = data.Choices.split(',').map(opt => opt.trim());
                        setCourseOptions(options);
                    }
                    console.log("Education Options:", data);
                }
            }
        } catch (error) {
            console.error("Error fetching education options:", error);
        }
    };

    const fetchCampaignOptions = async () => {
        try {
            const userId = localStorage.getItem('UserId') || "34594";
            const payload = {
                type: "CampaignName",
                UserId: userId
            };

            const response = await fetch(Get_campaign_for_edit, {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=utf-8" },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const result = await response.json();
                if (result.d) {
                    let data = typeof result.d === 'string' ? JSON.parse(result.d) : result.d;
                    if (Array.isArray(data)) {
                        // Extract ID and Name
                        const campaigns = data.map(item => ({
                            id: item.SrcmedCampID || item.Id || item.ID,
                            name: item.SrcmedCampName
                        })).filter(item => item.id && item.name);
                        setCampaignOptions(campaigns);
                        console.log("Campaign Options:", campaigns);
                    }
                }
            }
        } catch (error) {
            console.error("Error fetching campaign options:", error);
        }
    };

    const fetchMediumOptions = async () => {
        try {
            const userId = localStorage.getItem('UserId') || "34594";
            const payload = {
                type: "MediumName",
                UserId: userId
            };

            const response = await fetch(Get_campaign_for_edit, {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=utf-8" },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const result = await response.json();
                if (result.d) {
                    let data = typeof result.d === 'string' ? JSON.parse(result.d) : result.d;
                    if (Array.isArray(data)) {
                        // Extract ID and Name
                        const mediums = data.map(item => ({
                            id: item.SrcmedCampID || item.Id || item.ID,
                            name: item.SrcmedCampName
                        })).filter(item => item.id && item.name);
                        setMediumOptions(mediums);
                        console.log("Medium Options:", mediums);
                    }
                }
            }
        } catch (error) {
            console.error("Error fetching medium options:", error);
        }
    };

    const fetchSourceOptions = async () => {
        try {
            const userId = localStorage.getItem('UserId') || "34594";
            const payload = {
                type: "SourceName",
                UserId: userId
            };

            const response = await fetch(Get_campaign_for_edit, {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=utf-8" },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const result = await response.json();
                if (result.d) {
                    let data = typeof result.d === 'string' ? JSON.parse(result.d) : result.d;
                    if (Array.isArray(data)) {
                        // Extract ID and Name
                        const sources = data.map(item => ({
                            id: item.SrcmedCampID || item.Id || item.ID,
                            name: item.SrcmedCampName
                        })).filter(item => item.id && item.name);
                        setSourceOptions(sources);
                        console.log("Source Options:", sources);
                    }
                }
            }
        } catch (error) {
            console.error("Error fetching source options:", error);
        }
    };

    const fetchCountryOptions = async () => {
        try {
            const response = await fetch(Get_country_for_edit, {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=utf-8" },
                body: JSON.stringify({ Token: "-2295521862261168", Details: "" })
            });

            if (response.ok) {
                const result = await response.json();
                let data = result.Details || result.d || result;
                if (typeof data === 'string') {
                    try { data = JSON.parse(data); } catch(e) { data = []; }
                }
                if (Array.isArray(data)) {
                    // Extract country names (assuming field is 'Text', 'CountryName', or 'Name')
                    const countries = data.map(item => item.Text || item.CountryName || item.Name || item.Country).filter(Boolean);
                    setCountryOptions(countries);
                    console.log("Country Options:", countries);
                }
            }
        } catch (error) {
            console.error("Error fetching country options:", error);
        }
    };

    const handleSaveLead = async () => {
        try {
            setLoadingEditData(true);
            // Root level ParentId and UserId should be "34594" as per user example
            const rootUserId = "34594";
            const rootParentId = "34594";

            const leadId = editFormData.LeadId || editLeadData?.LeadId || editLeadData?.id || "18667180";

            const formatDateForAPI = (dateString, useHyphen = true) => {
                if (!dateString) return "";
                try {
                    const date = new Date(dateString);
                    if (isNaN(date.getTime())) return dateString;
                    const format = date.toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric'
                    });
                    // format is like "28 Feb 2026"
                    return useHyphen ? format.replace(/ /g, '-') : format;
                } catch (e) { return ""; }
            };

            // Mapping for all custom fields (editFormData Key -> FieldId)
            const customFieldMap = {
                "amount": "8844", "Service": "8845", "Charges": "8846", "Bank_Name_okl": "8847",
                "Bill_Amount": "8848", "Due_Date": "8849", "Card_Status": "8850", "Card_Type": "8851",
                "Bank_Name_okl_2": "8868", "Bill_Amount_2": "8869", "Due_Date_2": "8870", "Card_Status_2": "8871",
                "Card_Type_2": "8872", "Bank_Name_okl_3": "8873", "Bill_Amount_3": "8874", "Due_Date_3": "8875",
                "Card_Status_3": "8876", "Card_Type_3": "8877", "ClientID": "2686", "DOB": "1237",
                "NAME": "2503", "StudyLevel": "5291", "Course": "5292", "Centre_For_Education": "5293",
                "whatsaap_response": "2796", "Response": "2795", "User_Code": "6276",
                "Company_Incorporation_Date": "7580", "MCA_Registered_City": "7581", "Equity_Percentage": "7583",
                "Mandate_Start_Date": "7585", "Mandate_End_Date": "7586", "OPE_Preapproval": "7587",
                "Business_Referral_Mandate": "7588", "Addendum": "7589", "Project_Name": "7620",
                "is_Adult": "7692", "Locate_Our_Office": "8153", "test121": "8167",
                "number_of_users": "8244", "rrtr": "8580", "dytdutdtjg": "8629",
                "pending_amount": "8630", "warranty_valid_till": "8780", "warranty_start_date": "8781",
                "product": "8066", "Select_Option": "8899", "DATE_TIME": "8903",
                "monthly_EMI": "8994", "Demo_date": "9513", "new_test": "10056",
                "trest": "10365", "testing09099": "10528", "upload_doc": "10545",
                "gender": "10546"
            };

            const lstCustomField = Object.entries(customFieldMap).map(([key, id]) => {
                let value = editFormData[key]?.toString() || "";

                // Specific fallbacks from user's latest example payload
                if (id === "8849" && !value) value = "01 Jan 1900"; // Due_Date (No hyphen in example)
                if (id === "1237" && !value) value = "28-Aug-2023"; // DOB
                if (id === "2686" && !value) value = "0"; // ClientID
                if (id === "2503" && !value) value = "0"; // NAME
                if (id === "5291" && !value) value = "Diploma"; // StudyLevel
                if (id === "5292" && !value) value = "Diploma in Computers"; // Course
                if (id === "5293" && !value) value = "Delhi"; // Centre_For_Education
                if (id === "2796" && !value) value = "0";
                if (id === "2795" && !value) value = "0";
                if (id === "6276" && !value) value = "0";
                if (id === "7620" && !value) value = "1"; // Project_Name
                if (id === "7692" && !value) value = "yes"; // is_Adult
                if (id === "8167" && !value) value = "11"; // test121
                if (id === "8629" && !value) value = "28-Jan-2030"; // dytdutdtjg
                if (id === "8630" && !value) value = "01-Feb-1938"; // pending_amount
                if (id === "8066" && !value) value = "01-Dec-1903"; // product
                if (id === "8903" && !value) value = "28-Feb-2026"; // DATE_TIME
                if (id === "10528" && !value) value = "1"; // number_of_users
                if (id === "10546" && !value) value = "Male"; // gender

                // Format dates if they look like standard Date objects or ISO strings (ignore our manual fallbacks)
                if ((key.toLowerCase().includes("date") || key === "DOB" || key.includes("Appointment")) &&
                    value && !value.includes("-") && !value.includes(" ")) {
                    value = formatDateForAPI(value, id !== "8849");
                }

                return {
                    FieldId: id,
                    FieldValue: value
                };
            });

            // Mobile Formatting strictly as "+XX XXXXXXXXXX"
            let finalMobile = "";
            const dialCode = selectedCountry?.dialCode || "+974";
            const mobileInput = editFormData.MobileNo || "9780414526";
            if (mobileInput.includes("+")) {
                finalMobile = mobileInput;
            } else {
                finalMobile = `${dialCode} ${mobileInput}`.trim();
            }

            const payload = {
                Token: "-2295521862261168",
                Details: {
                    parentId: parseInt(rootParentId || 34594),
                    userId: parseInt(rootUserId || 34594),
                    LeadId: leadId ? parseInt(leadId.toString(), 10) : 0,
                    LeadNo: editFormData.LeadNo?.toString() || "",
                    PersonName: editFormData.PersonName || "",
                    CompanyName: editFormData.CompanyName || "",
                    MobileNo: finalMobile,
                    MobileNo1: editFormData.MobileNo1 || "",
                    MobileNo2: editFormData.MobileNo2 || "",
                    EmailID: editFormData.EmailID || editFormData.Email || "",
                    EmailID1: editFormData.EmailID1 || "",
                    EmailID2: editFormData.EmailID2 || "",
                    Country: editFormData.Country || "Select Country ",
                    State: editFormData.State || "",
                    City: editFormData.City || "",
                    PinCode: editFormData.PinCode?.toString() || editFormData.Pincode?.toString() || "0",
                    ResidentialAddress: editFormData.ResidentialAddress || "",
                    OfficialAddress: editFormData.OfficialAddress || "",
                    SourceName: editFormData.SourceName?.toString() || editFormData.Source?.toString() || "",
                    SourceId: 0,
                    MediumName: editFormData.MediumName?.toString() || "0",
                    MediumId: 0,
                    CampaignName: editFormData.CampaignName?.toString() || "0",
                    CampaignId: 0,
                    InitialRemarks: editFormData.InitialRemarks || "",
                    InitialRemarkId: 0,
                    WhereAddress: "",
                    WhereLatitude: "",
                    WhereLongitude: "",
                    LeadTags: editFormData.Tags || "",
                    PersonImage: "",
                    lstCustomField: lstCustomField
                }
            };

            console.log("Saving Edited Lead with Exact Payload:", JSON.stringify(payload, null, 2));

            const response = await fetch(SaveEdit, {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=utf-8" },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const result = await response.json();
                console.log("Save success:", result);
                alert("Lead details updated successfully!");
                onCloseEditModal();
                if (window.refreshFollowUpList) window.refreshFollowUpList();
            } else {
                console.error("Save failed with status:", response.status);
                alert("Failed to save changes. Status: " + response.status);
            }
        } catch (error) {
            console.error("Error in handleSaveLead:", error);
            alert("An error occurred while saving lead details.");
        } finally {
            setLoadingEditData(false);
        }
    };

    React.useEffect(() => {
        if (showLeadProfile && leadData) {
            fetchScorecardDetails();
            fetchLeadDetailById();
        }
    }, [showLeadProfile, leadData]);

    React.useEffect(() => {
        if (showEditModal && editLeadData) {
            fetchEditLeadDetails();
            fetchEducationOptions(); // Fetch course dropdown options
            fetchCampaignOptions(); // Fetch campaign dropdown options
            fetchMediumOptions(); // Fetch medium dropdown options
            fetchSourceOptions(); // Fetch source dropdown options
            fetchCountryOptions(); // Fetch country dropdown options
        }
    }, [showEditModal, editLeadData]);

    React.useEffect(() => {
        if (activeTab === 'Task' && leadData) {
            fetchTaskHistory();
        }
    }, [activeTab, leadData]);

    return (
        <div className="followup-filtration-container">
            {/* Toolbar Removed */}



            {/* Lead Profile Panel */}
            {(showLeadProfile || isProfileOpen) && (
                <div className="lead-profile-overlay" onClick={() => { onCloseLeadProfile?.(); setIsProfileOpen(false); }}>
                    <div className="lead-profile-panel" onClick={(e) => e.stopPropagation()}>
                        <div className="profile-header">
                            <div className="header-left">
                                <button className="back-to-followup-btn" onClick={() => { onCloseLeadProfile?.(); setIsProfileOpen(false); }}>
                                    × Back to Follow-Up
                                </button>
                            </div>
                        </div>

                        <div className="profile-body">
                            <div className="lead-profile-container">
                                {/* Basic Details Card */}
                                <div className="scorecard-section">
                                    <div className="section-header">
                                        <h3>Basic Details</h3>
                                    </div>
                                    <div className="basic-details-card">
                                        <div className="update-info-top">
                                            <div className="update-label">
                                                <Calendar size={14} /> <strong>Last Updated :</strong> {scorecardData?.CreatedOn || scorecardData?.Createdon || '28 Feb 2026 17:35:17'}
                                            </div>
                                        </div>
                                        <div className="details-header-row">
                                            <div className="avatar-section">
                                                <div className="large-avatar-v2">
                                                    <div className="avatar-circle-v2">
                                                        <img
                                                            src="https://kit19.com//assets/custom/img/img_avatar1.png"
                                                            alt="Profile"
                                                            style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }}
                                                        />
                                                    </div>
                                                    <div className="avatar-overlay-icon">
                                                        <User size={16} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="info-section">
                                                <h3 className="lead-name-v2">{scorecardData?.PersonName || leadDetailData?.personname || scorecardData?.MobileNo || '-'}</h3>
                                                <div className="details-grid-horizontal">
                                                    <div className="detail-pill"><Building size={14} /> <span>{leadDetailData?.companyname || scorecardData?.CompanyName || ''}</span></div>
                                                    <div className="detail-pill"><Phone size={14} /> <span>{leadDetailData?.mobileno || scorecardData?.MobileNo || '-'}</span></div>
                                                    <div className="detail-pill"><Mail size={14} /> <span>{leadDetailData?.emailid || scorecardData?.EmailId || ''}</span></div>
                                                    <div className="detail-pill"><MapPin size={14} /> <span>{leadDetailData?.country || scorecardData?.CountryName || ''}{leadDetailData?.city ? `-${leadDetailData.city}` : ''}</span></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Other Details Card */}
                                <div className="scorecard-section">
                                    <div className="section-header">
                                        <h3>Other Details</h3>
                                    </div>
                                    <div className="other-details-card-v2">
                                        <div className="details-row-v2">
                                            <div className="detail-col">
                                                <strong>Lead No :</strong> <span className="lead-no-badge">{scorecardData?.LeadNo || leadDetailData?.leadno || '-'}</span>
                                            </div>
                                            <div className="detail-col">
                                                <strong>Created On :</strong> {scorecardData?.CreatedOn || leadDetailData?.createdon || '-'}
                                            </div>
                                        </div>
                                        <div className="details-row-v2">
                                            <div className="detail-col">
                                                <strong>Source :</strong> {leadDetailData?.source || scorecardData?.SourceName || '-'}
                                            </div>
                                            <div className="detail-col">
                                                <strong>Medium :</strong> {leadDetailData?.medium || scorecardData?.MediumName || '-'}
                                            </div>
                                        </div>
                                        <div className="details-row-v2">
                                            <div className="detail-col">
                                                <strong>Campaign :</strong> {leadDetailData?.campaignname || scorecardData?.CampaignName || '-'}
                                            </div>
                                            <div className="detail-col">
                                                <strong>Created By :</strong> {leadDetailData?.createdby || scorecardData?.CreatedBy || '-'}
                                            </div>
                                        </div>
                                        <div className="details-row-v2">
                                            <div className="detail-col full">
                                                <strong>Address :</strong> {leadDetailData?.officeaddress || scorecardData?.ResidentialAddress || '-'}
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="more-action"
                                        onClick={() => setShowMoreOtherDetails(!showMoreOtherDetails)}
                                    >
                                        {showMoreOtherDetails ? '▲ Less..' : '▼ More..'}
                                    </div>
                                    {showMoreOtherDetails && (
                                        <div className="more-details-scroll-container">
                                            {!leadDetailData ? (
                                                <div style={{ padding: '20px', textAlign: 'center', color: '#888', fontSize: '13px' }}>Loading details...</div>
                                            ) : (
                                                <table className="more-details-table">
                                                    <thead>
                                                        <tr>
                                                            <th>Field</th>
                                                            <th>Value</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {Object.entries(leadDetailData)
                                                            .filter(([key]) => {
                                                                const excludeKeys = ['personname', 'companyname', 'mobileno', 'phones', 'emailid', 'emails', 'state', 'createdon', 'modifiedon', 'leadno', 'campaignname', 'source', 'medium', 'createdby', 'address', 'officeaddress', 'id'];
                                                                return !excludeKeys.includes(key.toLowerCase());
                                                            })
                                                            .sort(([a], [b]) => a.localeCompare(b))
                                                            .map(([key, value]) => (
                                                                <tr key={key}>
                                                                    <td className="more-detail-key">{key}</td>
                                                                    <td className="more-detail-value">{value !== null && value !== undefined && value !== '' ? String(value) : ''}</td>
                                                                </tr>
                                                            ))}
                                                    </tbody>
                                                </table>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Tabs System */}
                                <div className="profile-tabs-wrapper">
                                    <div className="tabs-nav">
                                        {[
                                            'Activities', 'Followup Details', 'Notes', 'Documents',
                                            'Task', 'Appointment', 'Chat Log', 'Webform',
                                            'Pipeline', 'WaChat Log'
                                        ].map(tab => (
                                            <button
                                                key={tab}
                                                className={`tab-nav-item ${activeTab === tab ? 'active' : ''}`}
                                                onClick={() => setActiveTab(tab)}
                                            >
                                                {tab}
                                            </button>
                                        ))}
                                        <button className="tabs-extra"><MoreHorizontal size={18} /></button>
                                    </div>

                                    <div className="tab-pane-content">
                                        {activeTab === 'Activities' && (
                                            <div className="activities-pane">
                                                <div className="pane-header">
                                                    <h4>Lead Activities <Plus size={16} className="add-icon" /></h4>
                                                </div>
                                                <div className="activity-feed">
                                                    {/* Matching the screenshot timeline */}
                                                    <div className="feed-item">
                                                        <div className="feed-icon"><Settings size={18} /></div>
                                                        <div className="feed-content">
                                                            <div className="feed-text">
                                                                kmukesh343 added a followup to leadno {scorecardData?.LeadNo || '627337'} with status Call-Back. Lead was assigned to no one
                                                            </div>
                                                            <div className="feed-time">28-Feb-2026 17:35:19</div>
                                                        </div>
                                                    </div>
                                                    <div className="feed-item">
                                                        <div className="feed-icon"><User size={18} /></div>
                                                        <div className="feed-content">
                                                            <div className="feed-text">
                                                                Lead Assigned to
                                                            </div>
                                                            <div className="feed-subtext">
                                                                Lead with name {scorecardData?.PersonName || scorecardData?.MobileNo || '916204593134'} is assigned to kmukesh343 by kmukesh343
                                                            </div>
                                                            <div className="feed-time">28-Feb-2026 17:35:19</div>
                                                        </div>
                                                    </div>
                                                    <div className="feed-item">
                                                        <div className="feed-icon"><Plus size={18} /></div>
                                                        <div className="feed-content">
                                                            <div className="feed-text">
                                                                Lead added
                                                            </div>
                                                            <div className="feed-subtext">
                                                                Lead with name {scorecardData?.PersonName || scorecardData?.MobileNo || '916204593134'} was added by kmukesh343
                                                            </div>
                                                            <div className="feed-time">28-Feb-2026 17:35:17</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="feed-footer">
                                                    <button className="group-by-btn">Group by</button>
                                                </div>
                                            </div>
                                        )}
                                        {activeTab !== 'Activities' && (
                                            <div className="pane-empty">
                                                <p>Information for <strong>{activeTab}</strong> will be displayed here.</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Lead Modal */}
            {showEditModal && (
                <div className="lead-edit-overlay" onClick={onCloseEditModal}>
                    <div className="lead-edit-panel" onClick={(e) => e.stopPropagation()}>
                        <div className="edit-header">
                            <div className="header-left">
                                <button className="back-btn" onClick={onCloseEditModal}>
                                    <X size={20} />
                                </button>
                                <h2>Back to Follow-Up</h2>
                            </div>
                        </div>

                        <div className="edit-body">
                            {loadingEditData ? (
                                <div className="loading-state">Loading lead details...</div>
                            ) : (
                                <div className="edit-form-container">
                                    {/* Basic Details Section */}
                                    <div className="edit-section">
                                        <h3 className="section-title">Basic Details</h3>
                                        <div className="form-grid">
                                            <div className="form-avatar-section">
                                                <div className="edit-avatar">
                                                    <User size={40} />
                                                </div>
                                            </div>

                                            <div className="form-row-two-col">
                                                <div className="form-group search-group">
                                                    <label>Name *</label>
                                                    <div className="search-input-wrapper">
                                                        <input
                                                            type="text"
                                                            value={editFormData?.Name || editFormData?.PersonName || editFormData?.personname || ''}
                                                            onChange={(e) => handleLeadSearch(e.target.value, 'Name')}
                                                            onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                                                            placeholder="Enter name"
                                                            autoComplete="off"
                                                        />
                                                        {isSearchingLeads && <div className="search-loader-mini"></div>}
                                                    </div>
                                                    {showSuggestions && leadSearchSuggestions.length > 0 && (
                                                        <div className="suggestions-dropdown">
                                                            {leadSearchSuggestions.map((lead, index) => (
                                                                <div
                                                                    key={lead.LeadId || lead.id || index}
                                                                    className="suggestion-item"
                                                                    onClick={() => handleSelectSuggestion(lead)}
                                                                >
                                                                    <div className="suggestion-info">
                                                                        <span className="suggestion-name">{lead.PersonName || lead.Name || lead.name}</span>
                                                                        <span className="suggestion-detail">{lead.MobileNo || lead.EmailID || lead.Email}</span>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="form-group">
                                                    <label>Company</label>
                                                    <input
                                                        type="text"
                                                        value={editFormData?.Company || editFormData?.CompanyName || editFormData?.companyname || ''}
                                                        onChange={(e) => setEditFormData({ ...editFormData, Company: e.target.value })}
                                                        placeholder="Company name"
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-row-two-col">
                                                <div className="form-group">
                                                    <label>Mobile</label>
                                                    <div className="phone-input-group">
                                                        <div className="country-selector" onClick={() => setIsCountryDropdownOpen(!isCountryDropdownOpen)}>
                                                            <span className="selected-flag">{selectedCountry.flag}</span>
                                                            <span className="selected-dial-code">{selectedCountry.dialCode}</span>
                                                            <ChevronDown size={14} className={`selector-arrow ${isCountryDropdownOpen ? 'open' : ''}`} />
                                                        </div>

                                                        {isCountryDropdownOpen && (
                                                            <div className="country-dropdown">
                                                                <div className="country-search-box">
                                                                    <Search size={14} />
                                                                    <input
                                                                        type="text"
                                                                        placeholder="Search country..."
                                                                        value={countrySearch}
                                                                        onChange={(e) => setCountrySearch(e.target.value)}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                        autoFocus
                                                                    />
                                                                </div>
                                                                <div className="country-list-scroll">
                                                                    {countryList
                                                                        .filter(c => c.name.toLowerCase().includes(countrySearch.toLowerCase()) || c.dialCode.includes(countrySearch))
                                                                        .map((country, idx) => (
                                                                            <div
                                                                                key={idx}
                                                                                className={`country-option ${selectedCountry.code === country.code ? 'selected' : ''}`}
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    setSelectedCountry(country);
                                                                                    setIsCountryDropdownOpen(false);
                                                                                    setCountrySearch("");
                                                                                }}
                                                                            >
                                                                                <span className="option-flag">{country.flag}</span>
                                                                                <span className="option-name">{country.name}</span>
                                                                                <span className="option-code">{country.dialCode}</span>
                                                                            </div>
                                                                        ))
                                                                    }
                                                                </div>
                                                            </div>
                                                        )}

                                                        <input
                                                            type="text"
                                                            value={editFormData?.MobileNo || editFormData?.Mobile || editFormData?.mobileno || ''}
                                                            onChange={(e) => setEditFormData({ ...editFormData, MobileNo: e.target.value })}
                                                            placeholder="9780414526"
                                                        />
                                                        <button className="phone-btn">+</button>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label>Email</label>
                                                    <div className="email-input-group">
                                                        <input
                                                            type="email"
                                                            value={editFormData?.Email || editFormData?.EmailId || editFormData?.emailid || ''}
                                                            onChange={(e) => setEditFormData({ ...editFormData, Email: e.target.value })}
                                                            placeholder="email@example.com"
                                                        />
                                                        <button className="email-btn">+</button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-row-three-col">
                                                <div className="form-group">
                                                    <label>Country</label>
                                                    <select
                                                        value={editFormData?.Country || editFormData?.country || ''}
                                                        onChange={(e) => setEditFormData({ ...editFormData, Country: e.target.value })}
                                                    >
                                                        <option value="">Select Country</option>
                                                        {countryOptions.map((option, index) => (
                                                            <option key={index} value={option}>{option}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label>State</label>
                                                    <select
                                                        value={editFormData?.State || editFormData?.state || ''}
                                                        onChange={(e) => setEditFormData({ ...editFormData, State: e.target.value })}
                                                    >
                                                        <option value="">Select State</option>
                                                        <option value="Badakhshan">Badakhshan</option>
                                                        <option value="Maharashtra">Maharashtra</option>
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label>City</label>
                                                    <select
                                                        value={editFormData?.City || editFormData?.city || ''}
                                                        onChange={(e) => setEditFormData({ ...editFormData, City: e.target.value })}
                                                    >
                                                        <option value="">Select City</option>
                                                        <option value="Qalawdewm">Qalawdewm</option>
                                                        <option value="Mumbai">Mumbai</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Other Details Section */}
                                    <div className="edit-section">
                                        <h3 className="section-title">Other Details</h3>
                                        <div className="form-grid">
                                            <div className="form-row-three-col">
                                                <div className="form-group">
                                                    <label>Medium</label>
                                                    <select
                                                        value={editFormData?.Medium || editFormData?.MediumName || editFormData?.medium || ''}
                                                        onChange={(e) => setEditFormData({ ...editFormData, Medium: e.target.value })}
                                                    >
                                                        <option value="">Select Medium</option>
                                                        {mediumOptions.map((option, index) => (
                                                            <option key={option.id || index} value={option.id}>{option.name}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label>Campaign</label>
                                                    <select
                                                        value={editFormData?.Campaign || editFormData?.CampaignName || editFormData?.campaignname || ''}
                                                        onChange={(e) => setEditFormData({ ...editFormData, Campaign: e.target.value })}
                                                    >
                                                        <option value="">Select Campaign</option>
                                                        {campaignOptions.map((option, index) => (
                                                            <option key={option.id || index} value={option.id}>{option.name}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label>Source *</label>
                                                    <select
                                                        value={editFormData?.Source || editFormData?.SourceName || editFormData?.source || ''}
                                                        onChange={(e) => setEditFormData({ ...editFormData, Source: e.target.value })}
                                                    >
                                                        <option value="">Select Source</option>
                                                        {sourceOptions.map((option, index) => (
                                                            <option key={option.id || index} value={option.id}>{option.name}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="form-row-two-col">
                                                <div className="form-group">
                                                    <label>Residential Address</label>
                                                    <textarea
                                                        value={editFormData?.ResidentialAddress || editFormData?.residentialaddress || ''}
                                                        onChange={(e) => setEditFormData({ ...editFormData, ResidentialAddress: e.target.value })}
                                                        placeholder="Enter residential address"
                                                        rows="3"
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Official Address</label>
                                                    <textarea
                                                        value={editFormData?.OfficialAddress || editFormData?.official_address || editFormData?.officialaddress || ''}
                                                        onChange={(e) => setEditFormData({ ...editFormData, OfficialAddress: e.target.value })}
                                                        placeholder="Enter official address"
                                                        rows="3"
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group full-width">
                                                <label>Initial Remarks</label>
                                                <textarea
                                                    value={editFormData?.InitialRemarks || ''}
                                                    onChange={(e) => setEditFormData({ ...editFormData, InitialRemarks: e.target.value })}
                                                    placeholder="Enter initial remarks"
                                                    rows="2"
                                                />
                                            </div>

                                            <div className="form-group full-width">
                                                <label>Pincode</label>
                                                <input
                                                    type="text"
                                                    value={editFormData?.Pincode || ''}
                                                    onChange={(e) => setEditFormData({ ...editFormData, Pincode: e.target.value })}
                                                    placeholder="123456"
                                                />
                                            </div>

                                            <div className="form-group full-width search-group">
                                                <label>Lead Tags</label>
                                                <div className="search-input-wrapper">
                                                    <input
                                                        type="text"
                                                        value={editFormData?.LeadTags || ''}
                                                        onChange={(e) => {
                                                            console.log("Lead Tags onChange triggered with:", e.target.value);
                                                            handleLeadSearch(e.target.value, 'LeadTags');
                                                        }}
                                                        onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                                                        placeholder="Search tags or leads..."
                                                        autoComplete="off"
                                                    />
                                                    {isSearchingLeads && <div className="search-loader-mini"></div>}
                                                </div>
                                                <small className="help-text">Please press comma, tab, or enter key for generating the tag name, or you can also generate a tag by copy and paste with comma separated value.</small>

                                                {showSuggestions && leadSearchSuggestions.length > 0 && (
                                                    <div className="suggestions-dropdown">
                                                        {leadSearchSuggestions.map((lead, index) => (
                                                            <div
                                                                key={lead.LeadId || lead.id || index}
                                                                className="suggestion-item"
                                                                onClick={() => handleSelectSuggestion(lead)}
                                                            >
                                                                <div className="suggestion-info">
                                                                    <span className="suggestion-name">{lead.PersonName || lead.Name || lead.name}</span>
                                                                    <span className="suggestion-detail">{lead.MobileNo || lead.EmailID || lead.Email}</span>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>

                                            {/* Hardcoded Fields from Screenshots */}
                                            <div className="edit-section">
                                                <div className="form-grid">
                                                    {/* Row 1 */}
                                                    <div className="form-row-three-col">
                                                        <div className="form-group">
                                                            <label>amount</label>
                                                            <input type="text" value={editFormData?.amount || ''} onChange={(e) => setEditFormData({ ...editFormData, amount: e.target.value })} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Service</label>
                                                            <input type="text" value={editFormData?.Service || ''} onChange={(e) => setEditFormData({ ...editFormData, Service: e.target.value })} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Charges</label>
                                                            <input type="text" value={editFormData?.Charges || ''} onChange={(e) => setEditFormData({ ...editFormData, Charges: e.target.value })} />
                                                        </div>
                                                    </div>

                                                    {/* Row 2 */}
                                                    <div className="form-row-three-col">
                                                        <div className="form-group">
                                                            <label>Bank_Name_okl</label>
                                                            <input type="text" value={editFormData?.Bank_Name_okl || ''} onChange={(e) => setEditFormData({ ...editFormData, Bank_Name_okl: e.target.value })} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Bill_Amount</label>
                                                            <input type="text" value={editFormData?.Bill_Amount || ''} onChange={(e) => setEditFormData({ ...editFormData, Bill_Amount: e.target.value })} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Due_Date</label>
                                                            <input type="date" value={editFormData?.Due_Date ? editFormData.Due_Date.split('T')[0] : ''} onChange={(e) => setEditFormData({ ...editFormData, Due_Date: e.target.value })} />
                                                        </div>
                                                    </div>

                                                    {/* Row 3 */}
                                                    <div className="form-row-three-col">
                                                        <div className="form-group">
                                                            <label>Card_Status</label>
                                                            <input type="text" value={editFormData?.Card_Status || ''} onChange={(e) => setEditFormData({ ...editFormData, Card_Status: e.target.value })} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Card_Type</label>
                                                            <input type="text" value={editFormData?.Card_Type || ''} onChange={(e) => setEditFormData({ ...editFormData, Card_Type: e.target.value })} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Bank_Name_okl_2</label>
                                                            <input type="text" value={editFormData?.Bank_Name_okl_2 || ''} onChange={(e) => setEditFormData({ ...editFormData, Bank_Name_okl_2: e.target.value })} />
                                                        </div>
                                                    </div>

                                                    {/* Row 4 */}
                                                    <div className="form-row-three-col">
                                                        <div className="form-group">
                                                            <label>Bill_Amount_2</label>
                                                            <input type="text" value={editFormData?.Bill_Amount_2 || ''} onChange={(e) => setEditFormData({ ...editFormData, Bill_Amount_2: e.target.value })} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Due_Date_2</label>
                                                            <input type="date" value={editFormData?.Due_Date_2 ? editFormData.Due_Date_2.split('T')[0] : ''} onChange={(e) => setEditFormData({ ...editFormData, Due_Date_2: e.target.value })} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Card_Status_2</label>
                                                            <input type="text" value={editFormData?.Card_Status_2 || ''} onChange={(e) => setEditFormData({ ...editFormData, Card_Status_2: e.target.value })} />
                                                        </div>
                                                    </div>

                                                    {/* Row 5 */}
                                                    <div className="form-row-three-col">
                                                        <div className="form-group">
                                                            <label>Card_Type_2</label>
                                                            <input type="text" value={editFormData?.Card_Type_2 || ''} onChange={(e) => setEditFormData({ ...editFormData, Card_Type_2: e.target.value })} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Bank_Name_okl_3</label>
                                                            <input type="text" value={editFormData?.Bank_Name_okl_3 || ''} onChange={(e) => setEditFormData({ ...editFormData, Bank_Name_okl_3: e.target.value })} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Bill_Amount_3</label>
                                                            <input type="text" value={editFormData?.Bill_Amount_3 || ''} onChange={(e) => setEditFormData({ ...editFormData, Bill_Amount_3: e.target.value })} />
                                                        </div>
                                                    </div>

                                                    {/* Row 6 */}
                                                    <div className="form-row-three-col">
                                                        <div className="form-group">
                                                            <label>Due_Date_3</label>
                                                            <input type="date" value={editFormData?.Due_Date_3 ? editFormData.Due_Date_3.split('T')[0] : ''} onChange={(e) => setEditFormData({ ...editFormData, Due_Date_3: e.target.value })} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Card_Status_3</label>
                                                            <input type="text" value={editFormData?.Card_Status_3 || ''} onChange={(e) => setEditFormData({ ...editFormData, Card_Status_3: e.target.value })} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Card_Type_3</label>
                                                            <input type="text" value={editFormData?.Card_Type_3 || ''} onChange={(e) => setEditFormData({ ...editFormData, Card_Type_3: e.target.value })} />
                                                        </div>
                                                    </div>

                                                    {/* Row 7 */}
                                                    <div className="form-row-three-col">
                                                        <div className="form-group">
                                                            <label>Client ID</label>
                                                            <input type="text" value={editFormData?.ClientID || ''} onChange={(e) => setEditFormData({ ...editFormData, ClientID: e.target.value })} placeholder="0" />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>DOB</label>
                                                            <input type="date" value={editFormData?.DOB ? editFormData.DOB.split('T')[0] : ''} onChange={(e) => setEditFormData({ ...editFormData, DOB: e.target.value })} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>NAME</label>
                                                            <input type="text" value={editFormData?.NAME || ''} onChange={(e) => setEditFormData({ ...editFormData, NAME: e.target.value })} placeholder="0" />
                                                        </div>
                                                    </div>

                                                    {/* Row 8 */}
                                                    <div className="form-row-three-col">
                                                        <div className="form-group">
                                                            <label>Study Level</label>
                                                            <select value={editFormData?.StudyLevel || ''} onChange={(e) => setEditFormData({ ...editFormData, StudyLevel: e.target.value })}>
                                                                <option value="">Select</option>
                                                                <option value="Diploma">Diploma</option>
                                                                <option value="Graduate">Graduate</option>
                                                                <option value="Post Graduate">Post Graduate</option>
                                                            </select>
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Course</label>
                                                            <select value={editFormData?.Course || ''} onChange={(e) => setEditFormData({ ...editFormData, Course: e.target.value })}>
                                                                <option value="">Select</option>
                                                                {courseOptions.map((opt, i) => <option key={i} value={opt}>{opt}</option>)}
                                                            </select>
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Centre_For Education</label>
                                                            <select value={editFormData?.Centre_For_Education || ''} onChange={(e) => setEditFormData({ ...editFormData, Centre_For_Education: e.target.value })}>
                                                                <option value="">Select</option>
                                                                <option value="Delhi">Delhi</option>
                                                                <option value="Jaipur">Jaipur</option>
                                                                <option value="Kota">Kota</option>
                                                                <option value="Lucknow">Lucknow</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    {/* Row 9 */}
                                                    <div className="form-row-three-col">
                                                        <div className="form-group">
                                                            <label>whatsaap_response</label>
                                                            <input type="text" value={editFormData?.whatsaap_response || ''} onChange={(e) => setEditFormData({ ...editFormData, whatsaap_response: e.target.value })} placeholder="0" />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Response</label>
                                                            <input type="text" value={editFormData?.Response || ''} onChange={(e) => setEditFormData({ ...editFormData, Response: e.target.value })} placeholder="0" />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>User_Code</label>
                                                            <input type="text" value={editFormData?.User_Code || ''} onChange={(e) => setEditFormData({ ...editFormData, User_Code: e.target.value })} placeholder="0" />
                                                        </div>
                                                    </div>

                                                    {/* Row 10 */}
                                                    <div className="form-row-three-col">
                                                        <div className="form-group">
                                                            <label>Company_Incorporation_Date</label>
                                                            <input type="date" value={editFormData?.Company_Incorporation_Date ? editFormData.Company_Incorporation_Date.split('T')[0] : ''} onChange={(e) => setEditFormData({ ...editFormData, Company_Incorporation_Date: e.target.value })} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>MCA_Registered_City</label>
                                                            <input type="text" value={editFormData?.MCA_Registered_City || ''} onChange={(e) => setEditFormData({ ...editFormData, MCA_Registered_City: e.target.value })} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Equity_Percentage</label>
                                                            <input type="text" value={editFormData?.Equity_Percentage || ''} onChange={(e) => setEditFormData({ ...editFormData, Equity_Percentage: e.target.value })} />
                                                        </div>
                                                    </div>

                                                    {/* Row 11 */}
                                                    <div className="form-row-three-col">
                                                        <div className="form-group">
                                                            <label>Mandate_Start_Date</label>
                                                            <input type="date" value={editFormData?.Mandate_Start_Date ? editFormData.Mandate_Start_Date.split('T')[0] : ''} onChange={(e) => setEditFormData({ ...editFormData, Mandate_Start_Date: e.target.value })} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Mandate_End_Date</label>
                                                            <input type="date" value={editFormData?.Mandate_End_Date ? editFormData.Mandate_End_Date.split('T')[0] : ''} onChange={(e) => setEditFormData({ ...editFormData, Mandate_End_Date: e.target.value })} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>OPE_Preapproval</label>
                                                            <input type="text" value={editFormData?.OPE_Preapproval || ''} onChange={(e) => setEditFormData({ ...editFormData, OPE_Preapproval: e.target.value })} />
                                                        </div>
                                                    </div>

                                                    {/* Row 12 */}
                                                    <div className="form-row-three-col">
                                                        <div className="form-group">
                                                            <label>Business_Referral_Mandate</label>
                                                            <input type="text" value={editFormData?.Business_Referral_Mandate || ''} onChange={(e) => setEditFormData({ ...editFormData, Business_Referral_Mandate: e.target.value })} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Addendum</label>
                                                            <input type="text" value={editFormData?.Addendum || ''} onChange={(e) => setEditFormData({ ...editFormData, Addendum: e.target.value })} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Project_Name</label>
                                                            <input type="text" value={editFormData?.Project_Name || ''} onChange={(e) => setEditFormData({ ...editFormData, Project_Name: e.target.value })} placeholder="1" />
                                                        </div>
                                                    </div>

                                                    {/* Row 13 */}
                                                    <div className="form-row-three-col">
                                                        <div className="form-group">
                                                            <label>is_Adult</label>
                                                            <div className="radio-group horizontal">
                                                                <label><input type="radio" name="is_Adult" value="yes" checked={editFormData?.is_Adult === 'yes'} onChange={(e) => setEditFormData({ ...editFormData, is_Adult: e.target.value })} /> yes</label>
                                                                <label><input type="radio" name="is_Adult" value="no" checked={editFormData?.is_Adult === 'no'} onChange={(e) => setEditFormData({ ...editFormData, is_Adult: e.target.value })} /> no</label>
                                                                <label><input type="radio" name="is_Adult" value="don't wish to answer" checked={editFormData?.is_Adult === "don't wish to answer"} onChange={(e) => setEditFormData({ ...editFormData, is_Adult: e.target.value })} /> don't wish to answer</label>
                                                            </div>
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Locate_Our_Office</label>
                                                            <input type="text" value={editFormData?.Locate_Our_Office || ''} onChange={(e) => setEditFormData({ ...editFormData, Locate_Our_Office: e.target.value })} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>test121</label>
                                                            <input type="text" value={editFormData?.test121 || ''} onChange={(e) => setEditFormData({ ...editFormData, test121: e.target.value })} placeholder="11" />
                                                        </div>
                                                    </div>

                                                    {/* Row 14 */}
                                                    <div className="form-grid-three-col">
                                                        <div className="form-group">
                                                            <label>number_of_users</label>
                                                            <input type="text" value={editFormData?.number_of_users || ''} onChange={(e) => setEditFormData({ ...editFormData, number_of_users: e.target.value })} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>rrtr</label>
                                                            <input type="text" value={editFormData?.rrtr || ''} onChange={(e) => setEditFormData({ ...editFormData, rrtr: e.target.value })} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>dytdutdtjg</label>
                                                            <input type="text" value={editFormData?.dytdutdtjg || ''} onChange={(e) => setEditFormData({ ...editFormData, dytdutdtjg: e.target.value })} />
                                                        </div>
                                                    </div>

                                                    {/* Row 15 */}
                                                    <div className="form-grid-three-col">
                                                        <div className="form-group">
                                                            <label>pending_amount</label>
                                                            <input type="text" value={editFormData?.pending_amount || ''} onChange={(e) => setEditFormData({ ...editFormData, pending_amount: e.target.value })} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>warranty_valid_till</label>
                                                            <input type="date" value={editFormData?.warranty_valid_till ? editFormData.warranty_valid_till.split('T')[0] : ''} onChange={(e) => setEditFormData({ ...editFormData, warranty_valid_till: e.target.value })} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>warranty_start_date</label>
                                                            <input type="date" value={editFormData?.warranty_start_date ? editFormData.warranty_start_date.split('T')[0] : ''} onChange={(e) => setEditFormData({ ...editFormData, warranty_start_date: e.target.value })} />
                                                        </div>
                                                    </div>

                                                    {/* Row 16 */}
                                                    <div className="form-grid-three-col">
                                                        <div className="form-group">
                                                            <label>product</label>
                                                            <input type="text" value={editFormData?.product || ''} onChange={(e) => setEditFormData({ ...editFormData, product: e.target.value })} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Select_Option</label>
                                                            <input type="text" value={editFormData?.Select_Option || ''} onChange={(e) => setEditFormData({ ...editFormData, Select_Option: e.target.value })} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>DATE_TIME</label>
                                                            <input type="date" value={editFormData?.DATE_TIME ? editFormData.DATE_TIME.split('T')[0] : ''} onChange={(e) => setEditFormData({ ...editFormData, DATE_TIME: e.target.value })} />
                                                        </div>
                                                    </div>

                                                    {/* Row 17 */}
                                                    <div className="form-row-three-col">
                                                        <div className="form-group">
                                                            <label>monthly_EMI</label>
                                                            <input type="text" value={editFormData?.monthly_EMI || ''} onChange={(e) => setEditFormData({ ...editFormData, monthly_EMI: e.target.value })} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Demo_date</label>
                                                            <input type="text" value={editFormData?.Demo_date || ''} onChange={(e) => setEditFormData({ ...editFormData, Demo_date: e.target.value })} placeholder="Demo_date (Minimum value 01-Jan-1900 ar" />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>new_test</label>
                                                            <input type="text" value={editFormData?.new_test || ''} onChange={(e) => setEditFormData({ ...editFormData, new_test: e.target.value })} />
                                                        </div>
                                                    </div>

                                                    {/* Row 18 */}
                                                    <div className="form-row-three-col">
                                                        <div className="form-group">
                                                            <label>trest</label>
                                                            <input type="text" value={editFormData?.trest || ''} onChange={(e) => setEditFormData({ ...editFormData, trest: e.target.value })} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>testing09099</label>
                                                            <input type="text" value={editFormData?.testing09099 || ''} onChange={(e) => setEditFormData({ ...editFormData, testing09099: e.target.value })} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>upload_doc</label>
                                                            <input type="text" value={editFormData?.upload_doc || ''} onChange={(e) => setEditFormData({ ...editFormData, upload_doc: e.target.value })} />
                                                        </div>
                                                    </div>

                                                    {/* Row 19 */}
                                                    <div className="form-row-three-col">
                                                        <div className="form-group">
                                                            <label>official_address</label>
                                                            <input type="text" value={editFormData?.official_address || ''} onChange={(e) => setEditFormData({ ...editFormData, official_address: e.target.value })} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>test</label>
                                                            <input type="text" value={editFormData?.test || ''} onChange={(e) => setEditFormData({ ...editFormData, test: e.target.value })} placeholder="1" />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>KW_Requirement</label>
                                                            <input type="text" value={editFormData?.KW_Requirement || ''} onChange={(e) => setEditFormData({ ...editFormData, KW_Requirement: e.target.value })} />
                                                        </div>
                                                    </div>

                                                    <div className="form-row-three-col">
                                                        <div className="form-group">
                                                            <label>Gender__</label>
                                                            <div className="radio-group horizontal">
                                                                <label><input type="radio" name="gender" value="Male" checked={editFormData?.gender === 'Male'} onChange={(e) => setEditFormData({ ...editFormData, gender: e.target.value })} /> Male</label>
                                                                <label><input type="radio" name="gender" value="Female" checked={editFormData?.gender === 'Female'} onChange={(e) => setEditFormData({ ...editFormData, gender: e.target.value })} /> Female</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-actions">
                                                <button className="save-btn" onClick={handleSaveLead} disabled={loadingEditData}>
                                                    {loadingEditData ? 'Saving...' : 'Save'}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );

};

export default React.memo(FollowUpFilterationActions);


export const LeadDetails = (props) => {
    return <CommonLeadDetails {...props} module="followup" />;
};
